import React from 'react';
import { useLocation } from 'react-router-dom';
import { CalculatorRouteSkeleton } from './CalculatorRouteSkeleton';

const CALCULATOR_ROUTE_PREFIX = '/calculators/';

export const RouteFallback: React.FC = () => {
  const { pathname } = useLocation();
  const normalized = pathname.replace(/\/$/, '') || '/';

  if (normalized === '/' || normalized.startsWith(CALCULATOR_ROUTE_PREFIX)) {
    return <CalculatorRouteSkeleton />;
  }

  return (
    <div className="min-h-[30vh] flex items-center justify-center text-ink-muted text-sm" role="status">
      Loading page…
    </div>
  );
};
